import React from "react";

type FormFieldRowProps = {
    label: string;
    children: React.ReactNode;
};
export const FormFieldRow: React.FC<FormFieldRowProps> = ({label, children}) => {
    return (
        <div className="grid w-full grid-cols-1 gap-3 md:grid-cols-[180px_minmax(0,1fr)] md:items-center md:gap-4">
            <span className="text-lg leading-[26px] text-[#8c8c8c]">{label}</span>
            <div className="min-w-0">{children}</div>
        </div>
    );
};